module.exports = __webpack_public_path__ + "img/k.f07aab1c.jpg";